import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";

export function AddServicesSettings({ onSettingsChange, serviceSettings }) {
  const [settings, setSettings] = useState({
    visible: true, // Default to true
    websitePrice: "",
    bookable: false,
    upfrontPayable: false,
  });

  // ✅ FIX: Handle visibility change in the handleChange function instead of useEffect
  // Remove the problematic useEffect that was causing infinite loops

  useEffect(() => {
    if (serviceSettings) {
      setSettings(serviceSettings);
    }
  }, [serviceSettings]);

  // Update state and send data to the parent
  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    let updatedSettings = { ...settings, [name]: newValue };

    // ✅ Handle visibility logic here instead of in useEffect
    if (name === "visible" && !newValue) {
      // When visibility is turned off, clear website price and bookable
      updatedSettings = {
        ...updatedSettings,
        websitePrice: "",
        bookable: false,
      };
    }

    setSettings(updatedSettings);
    onSettingsChange(updatedSettings); // Send updated data to parent
  };

  return (
    <div>
      <Form>
        {/* Visible on Website Switch */}
        <Row className="mt-3 mb-1">
          <Form.Group as={Col} controlId="visible">
            <Form.Check
              type="switch"
              label="Visible on the website"
              name="visible"
              checked={settings.visible}
              onChange={handleChange}
            />
          </Form.Group>
        </Row>

        {/* Conditional Rendering for Price Input */}
        {settings.visible && (
          <>
            {/* Bookable Online Switch */}
            <Row className="mb-1 ms-2">
              <Form.Group as={Col} controlId="bookable">
                <Form.Check
                  type="switch"
                  label="Bookable online by patients"
                  name="bookable"
                  checked={settings.bookable}
                  onChange={handleChange}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3 ms-2">
              <Form.Group as={Col} controlId="websitePrice">
                <Form.Label>Website Price</Form.Label>
                <Form.Control
                  type="text"
                  name="websitePrice"
                  value={settings.websitePrice}
                  onChange={handleChange}
                  placeholder="Enter the price or price range to be displayed"
                />
              </Form.Group>
            </Row>
          </>
        )}

        {/* Payable Upfront Switch (Always Visible) */}
        <Row>
          <Form.Group as={Col} controlId="upfrontPayable">
            <Form.Check
              type="switch"
              label="Payable upfront"
              name="upfrontPayable"
              checked={settings.upfrontPayable}
              onChange={handleChange}
            />
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
}